import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

type IssuedSchedule = { year: number; month: number; schedule_id: string };

function scheduleValue(schedule: IssuedSchedule): string {
  return `${schedule.year}-${schedule.month}-${schedule.schedule_id}`;
}

function RosterListButton({
  issuedList,
  currentScheduleDate,
  setCurrentScheduleDate,
  variant = "default",
}: {
  issuedList: IssuedSchedule[];
  currentScheduleDate: IssuedSchedule;
  setCurrentScheduleDate: (value: IssuedSchedule) => void;
  variant?: "default" | "title";
}) {
  const selected = issuedList.find(
    (item) => scheduleValue(item) === scheduleValue(currentScheduleDate)
  ) ?? issuedList.find(
    (item) => Number(item.year) === Number(currentScheduleDate.year)
      && Number(item.month) === Number(currentScheduleDate.month)
  );

  return (
    <Select
      value={selected ? scheduleValue(selected) : ""}
      disabled={issuedList.length === 0}
      onValueChange={(value) => {
        const schedule = issuedList.find((item) => scheduleValue(item) === value);
        if (schedule) setCurrentScheduleDate(schedule);
      }}
    >
      <SelectTrigger
        aria-label="근무표 연월 선택"
        className={variant === "title"
          ? "w-[280px] data-[size=default]:h-12 rounded-none border-0 border-b border-border shadow-none text-[22px] font-semibold"
          : "w-[180px]"}
      >
        <SelectValue placeholder={`${currentScheduleDate.year}년 ${currentScheduleDate.month}월${variant === "title" ? " 근무표" : ""}`} />
      </SelectTrigger>
      <SelectContent position="popper" align="start">
        <SelectGroup>
          {issuedList.map((item) => (
            <SelectItem key={scheduleValue(item)} value={scheduleValue(item)}>
              {item.year}년 {item.month}월{variant === "title" ? " 근무표" : ""}
            </SelectItem>
          ))}
        </SelectGroup>
      </SelectContent>
    </Select>
  );
}

export default RosterListButton;
